// extracted by mini-css-extract-plugin
module.exports = {"base":"ResultCard_base__1_iIE","content":"ResultCard_content__34BXI"};